import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private _isMobile: boolean = false;

  constructor() {}

  //Setter and Getter of isMobile flag (used in the entire app)
  get isMobile(): boolean {
    return this._isMobile;
  }

  setIsMobile(state: boolean) {
    this._isMobile = state;
  }
}
